<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <template v-if="isPn">
        <!-- Botões dinâmicos para Medalhas -->
        <b-button
          v-for="button in badgesData"
          :key="button.id"
          variant="primary"
          @click="showModal(button.id)"
          class="ml-2 bagde-button"
        >
          <img
            :src="button.image"
            alt="Badge Image"
            class="bagde-button-image"
          />
        </b-button>
        <!-- Modal para exibir os detalhes do badge -->
        <BadgesModal v-model="showModalFlag" :badgeId="selectedBadgeId" />
      </template>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <whats-new-button class="d-none d-lg-block" />
      <dark-Toggler class="d-none d-lg-block" />
      <chat-navbar-button />
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/modules/dashboard/store/types";
import * as accountTypes from "@/modules/account/store/types";
import { BLink, BNavbarNav } from "bootstrap-vue";
import DarkToggler from "./components/DarkToggler";
import WhatsNewButton from "./components/WhatsNewButton.vue";
import NotificationDropdown from "@/modules/notification/components/NotificationDropdown";
import ChatNavbarButton from '@/modules/customer_chat/components/ChatNavbarButton.vue'
import UserDropdown from "./components/UserDropdown.vue";
import HelpLink from "./components/HelpLink";
import BadgesModal from "@/modules/dashboard/components/BadgesModal.vue";
import { isPnRole } from "@/constants/auth";
import { badgesDataDefault } from "@/constants/planner_gamification_badges_types";
import reportLockAware from '@/mixins/reportLockAware'

export default {
  components: {
    BLink,
    // Navbar Components
    BNavbarNav,
    DarkToggler,
    WhatsNewButton,
    NotificationDropdown,
    ChatNavbarButton,
    UserDropdown,
    HelpLink,
    BadgesModal,
  },
  mixins: [reportLockAware],
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      badgesData: badgesDataDefault,
      selectedBadgeId: null,
      showModalFlag: false,
    };
  },
  computed: {
    ...mapGetters({
      appointmentBadges: types.APPOINTMENT_BADGES,
      subscriptionBadges: types.SUBSCRIPTION_BADGES,
      roleBadges: types.ROLE_BADGES,
      epBadges: types.EP_BADGES,
      totalEarningsBadges: types.TOTAL_EARNINGS_BADGES,
      consortiumBadges: types.CONSORTIUM_BADGES,
      lifeTotalsBadges: types.LIFE_TOTALS_BADGES,
      user: accountTypes.USER,
    }),
    isPn: function () {
      return isPnRole(this.user?.user_contract_type_id);
    },
  },
  mounted() {
    if (this.isPn) {
      // Com report pendente a API recusa as medalhas (423): carregam quando o acesso for liberado.
      this.$nextTick(() => {
        this.runWhenReportUnlocked(this.getAllBadges)
      });
    }
  },
  methods: {
    ...mapActions({
      getAppointmentBadges: types.GET_APPOINTMENT_BADGES,
      getSubscriptionBadges: types.GET_SUBSCRIPTION_BADGES,
      getRoleBadges: types.GET_ROLE_BADGES,
      getEpBadges: types.GET_EP_BADGES,
      getTotalEarningsBadges: types.GET_TOTAL_EARNINGS_BADGES,
      getConsortiumBadges: types.GET_CONSORTIUM_BADGES,
      getLifetotalsBadges: types.GET_LIFE_TOTALS_BADGES,
    }),
    getAllBadges() {
      // Medalha que falhou (rede, 423 da trava…) fica com a imagem padrão — sem rejeição sem tratamento.
      const loaders = [
        [this.getRoleBadges, this.updateRoleBadgeImage],
        [this.getAppointmentBadges, this.updateAppointmentBadgeImage],
        [this.getSubscriptionBadges, this.updateSubscriptionBadgeImage],
        [this.getEpBadges, this.updateEpBadgeImage],
        [this.getLifetotalsBadges, this.updateVidaBadgeImage],
        [this.getConsortiumBadges, this.updateConsortiumBadgeImage],
        [this.getTotalEarningsBadges, this.updateTotalEarningsBadgeImage],
      ]
      loaders.forEach(([load, update]) => {
        load().then(() => update()).catch(() => {})
      })
    },
    updateRoleBadgeImage() {
      const medalhaRole = this.roleBadges.imageActive;
      const roleBadge = this.badgesData.find((badge) => badge.id == 1);
      if (roleBadge) roleBadge.image = medalhaRole;
    },
    updateAppointmentBadgeImage() {
      const medalhaAppointment = this.appointmentBadges.imageActive;
      const appointmentBadge = this.badgesData.find((badge) => badge.id == 2);
      if (appointmentBadge) appointmentBadge.image = medalhaAppointment;
    },
    updateSubscriptionBadgeImage() {
      const medalhaSubscription = this.subscriptionBadges.imageActive;
      const subscriptionBadge = this.badgesData.find((badge) => badge.id == 3);
      if (subscriptionBadge) subscriptionBadge.image = medalhaSubscription;
    },
    updateEpBadgeImage() {
      const medalhaEp = this.epBadges.imageActive;
      const epBadge = this.badgesData.find((badge) => badge.id == 4);
      if (epBadge) epBadge.image = medalhaEp;
    },
    updateVidaBadgeImage() {
      const medalhaVida = this.lifeTotalsBadges.imageActive;
      const vidaBadge = this.badgesData.find((badge) => badge.id == 5);
      if (vidaBadge) vidaBadge.image = medalhaVida;
    },
    updateConsortiumBadgeImage() {
      const medalhaConsortium = this.consortiumBadges.imageActive;
      const consortiumBadge = this.badgesData.find((badge) => badge.id == 6);
      if (consortiumBadge) consortiumBadge.image = medalhaConsortium;
    },
    updateTotalEarningsBadgeImage() {
      const medalhaTotalEarnings = this.totalEarningsBadges.imageActive;
      const totalEarningsBadge = this.badgesData.find((badge) => badge.id == 7);
      if (totalEarningsBadge) totalEarningsBadge.image = medalhaTotalEarnings;
    },
    showModal(badgeId) {
      this.selectedBadgeId = badgeId;
      this.showModalFlag = true;
    },
  },
};
</script>
<style>
.bagde-button {
  padding: 0;
  border: none;
  background-color: transparent !important;
  outline: none;
  box-shadow: none !important;
}
.bagde-button:active,
.bagde-button:focus {
  background-color: transparent !important;
}

.bagde-button-image {
  height: 38px;
}
</style>
